import {defineStore} from 'pinia'

const name = 'appModel'

export const useAppModelStore = defineStore(name,{

  id: name,

  state: () => ({
      records: [],
      current: 0,
    }
  ),

  actions: {

    add(payload) {
      this.records.push(payload);
    },
    update(payload) {
      this.records = this.records.map(elem => {
        if (elem.id === payload.id) {
          return Object.assign({}, elem, payload);
        }
        return elem;
      });
    },
    delete(payload) {
      const index = this.records.findIndex(elem => elem.id === payload.id);
      this.records.splice(index, 1);
    },
    load(payload) {
      this.records = payload;
    },
    setCurrentRecord( payload) {
      this.current = payload;
    },

  },
  getters: {
    getRecords: (state) => {
      let recs = JSON.parse(JSON.stringify(state.records));
      return recs;
    },
    isLoaded: (state) => {
      return state.records.length > 0;
    },
    getCurrentRecord: (state) => {
      return state.current;
    },
  }

})
